module.exports = __webpack_public_path__ + "static/mummy-223894e20284c178d863c587128aa92f.jpg";